export default __webpack_public_path__ + "static/home-screen-cf50d45fbb139432a7efd7d7207c52a8.webp";